import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { MainLayout } from "./components/layout/MainLayout";
import { LoadingScreen } from "./components/feedback/LoadingScreen";
import { RequireAuth } from "./auth/RequireAuth";
import { RequireModule } from "./auth/RequireModule";
import { LandingRoute } from "./auth/LandingRoute";
import { LoginPage } from "./auth/LoginPage";
import { UnauthorizedPage } from "./pages/UnauthorizedPage";
import { ForbiddenPage } from "./pages/ForbiddenPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { CopilotPage } from "./features/copilot/CopilotPage";
import { CopilotAdminPage } from "./features/settings/CopilotAdminPage";
import { DeploymentSettingsPage } from "./features/settings/DeploymentSettingsPage";

export function App(): JSX.Element {
  return (
    <Suspense fallback={<LoadingScreen message="Loading Copilot…" />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/forbidden" element={<ForbiddenPage />} />
        <Route element={<RequireAuth><MainLayout /></RequireAuth>}>
          <Route index element={<LandingRoute />} />
          <Route path="/copilot" element={<RequireModule module="copilot"><CopilotPage /></RequireModule>} />
          {/* Copilot administration: the `settings` module, OR the one action
              whose only screen lives inside it. The page renders only the tabs
              the principal holds, and the backend enforces every request
              either way. */}
          <Route
            path="/settings/copilot"
            element={
              <RequireModule module="settings" anyAction={["copilot.mcp_integrations_read"]}>
                <CopilotAdminPage />
              </RequireModule>
            }
          />
          {/* Platform settings. Each tab asks its own module again inside. */}
          <Route
            path="/settings"
            element={
              <RequireModule module="settings">
                <DeploymentSettingsPage />
              </RequireModule>
            }
          />
          {/* Internal AI agents used to live at /agents. They are now the
              agent sub-tabs of Copilot administration's Thinking models tab,
              so old links land where the screen went rather than on 404. */}
          <Route path="/agents" element={<Navigate to="/settings/copilot?tab=models" replace />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
